<template>
  <div class="info" id="info">
    <div class="cell_title">
      <div class="time_desc">
        <span class="r">总计用时：{{ allTimer }}</span>
        <span>本题用时：{{ timer }}</span>

        <!-- <template slot="title">  </template>
        <template slot="default"> </template>-->
      </div>
      <van-cell class="cell_title">
        <template slot="title">
          <div class="progress">
            <div class="strip" :style="{ width: progress }"></div>
          </div>
          <div class="title">
            <span
              class="type"
              v-if="test.list[test.listIndex].type == 'multiple_one'"
              >[单选题]</span
            >
            <span
              class="type"
              v-if="test.list[test.listIndex].type == 'multiple_many'"
              >[不定项]</span
            >
            <span v-html="test.list[test.listIndex].text"></span>
          </div>
        </template>
      </van-cell>
    </div>
    <van-cell title=" " class="noline">
      <template slot="label">
        <div class="askLi">
          <van-checkbox-group
            v-model="test.answer"
            v-if="test.list[test.listIndex].type == 'multiple_many'"
          >
            <van-checkbox
              :name="item.option"
              v-for="(item, index) in test.list[test.listIndex].options"
              :key="index"
            >
              <van-row type="flex" align="center">
                <van-col :span="2">
                  <span>{{ item.option }}.</span>
                </van-col>
                <van-col :span="22">
                  <span v-html="item.text"></span>
                </van-col>
              </van-row>
            </van-checkbox>
          </van-checkbox-group>
          <van-radio-group
            v-model="test.answer"
            v-if="test.list[test.listIndex].type == 'multiple_one'"
          >
            <van-radio
              :name="item.option"
              v-for="(item, index) in test.list[test.listIndex].options"
              :key="index"
            >
              <van-row type="flex" align="center">
                <van-col :span="2">
                  <span>{{ item.option }}.</span>
                </van-col>
                <van-col :span="22">
                  <div v-html="item.text" style="width:100%"></div>
                </van-col>
              </van-row>
            </van-radio>
          </van-radio-group>
        </div>
      </template>
    </van-cell>
    <div class="footer">
      <van-button block color="#69b8fe" :loading="butloading" @click="goUrl"
        >下一题</van-button
      >
    </div>
    <div class="dialog" v-show="show">
      <div class="title">{{ data.title }}</div>
      <div class="desc">
        <div>
          最佳用时：
          <span>{{ data.standardTime | format }}</span>
        </div>
        测评时间：
        <span>{{ data.examTime | format }}</span>
      </div>
      <img src="../../assets/tishi.svg" />
      <div class="tishi">
        <p>1.测评中可能出现多选题</p>
        <p>2.提交后不能回看上一题</p>
        <p>3.在测评时间内未完成视为无效</p>
      </div>
      <div class="footer">
        <van-button block color="#69b8fe" @click="startAnswer"
          >开始测评</van-button
        >
      </div>
    </div>
    <div class="dialog" v-show="isExist">
      <img src="../../assets/404.svg" class="mt" />
      <div class="tishi">
        <p>找不到该测评</p>
      </div>
    </div>
    <loadingPage :isShow="loading"></loadingPage>
    <!-- 草稿本 -->
    <div class="draft" @click="drawPageShow = true">
      <van-icon name="records" />
      <div>草稿</div>
    </div>
    <van-popup v-model="drawPageShow" class="drawPage" :overlay="false">
      <div class="box">
        <draw
          ref="in-draw-mask"
          :inRatio="3"
          :inLineColor="'#000'"
          :inLineWidth="3"
          :inShadowBlur="3"
        ></draw>
        <div class="but">
          <van-button
            plain
            hairline
            type="info"
            size="small"
            style="float: right;"
            @click="drawDelete"
            >清空</van-button
          >
          <van-button
            plain
            hairline
            type="primary"
            size="small"
            @click="drawPageShow = false"
            >关闭</van-button
          >
        </div>
      </div>
    </van-popup>
    <!-- 草稿本 -->
  </div>
</template>
<script>
import { replaceinfo } from "@/common/index";
import { assessApi } from "@/api/index";
import weixinshare from "@/wxsdk/share";
import loadingPage from "../loading";
import draw from "../../components/indraw/Index";
export default {
  components: {
    loadingPage,
    draw
  },
  data() {
    return {
      drawPageShow: false,
      loading: true,
      butloading: false,
      show: true,
      isExist: false,
      timer: "0分0秒",
      minutes: 0,
      seconds: 0,
      allTimer: "0分0秒",
      allMinutes: 0,
      allSeconds: 0,
      specialId: 0,
      isRestart: 0,
      data: {
        title: "",
        standardTime: 0,
        examId: 0,
        examTime: 0,
        list: [],
        listIndex: 0
      },
      test: {
        list: [
          {
            text: "",
            options: []
          }
        ],
        listIndex: 0,
        answer: [],
        startTime: 0,
        timeSender: null,
        timeSender1: null
      }
    };
  },
  mounted() {
    this.specialId = this.$route.params.id;
    this.startExam();
    const linkurl = "https://" + window.location.host;
    weixinshare(this.$titles, linkurl, this.$imgurls, this.$descs);
  },
  methods: {
    startExam() {
      let params = {
        specialId: this.specialId,
        isRestart: this.isRestart
      };
      assessApi.postStartExam(params).then(res => {
        this.loading = false;
        if (res.success) {
          let thisTime = parseInt(new Date().getTime() / 1000);
          this.data.title = res.data.name;
          this.data.examId = res.data.examId;
          this.data.examTime = res.data.examTime;
          this.data.standardTime = res.data.standardTime;
          this.data.list = res.data.tagList;
          this.test.startTime =
            res.data.lastQuestionPostTime == 0
              ? thisTime
              : res.data.lastQuestionPostTime;
          if (res.data.lastQuestionPostTime > 0) {
            let t = thisTime - res.data.lastQuestionPostTime;
            if (t > 60) {
              let m = parseInt(t / 60);
              let s = t - 60 * m;
              this.minutes = m;
              this.seconds = s;
            } else {
              this.seconds = t;
            }
          }
          if (res.data.countUseTime > 0) {
            let t =
              thisTime - res.data.lastQuestionPostTime + res.data.countUseTime;
            if (t > 60) {
              let m = parseInt(t / 60);
              let s = t - 60 * m;
              this.allMinutes = m;
              this.allSeconds = s;
            } else {
              this.allSeconds = t;
            }
          }
        } else {
          if (res.code == 20003) {
            this.show = false;
            this.$dialog
              .confirm({
                message:
                  "测评时间到，您未完成测评，本次测评无效，是否重新开始？",
                confirmButtonText: "重新测评",
                cancelButtonText: "退出"
              })
              .then(() => {
                this.isRestart = 1;
                this.show = true;
                this.startExam();
              })
              .catch(() => {
                this.$router.push({ name: "home" });
              });
          } else if (res.code == 20008) {
            this.isExist = true;
          } else {
            this.$toast.fail(res.msg);
          }
        }
      });
    },
    getExamSubject() {
      this.butloading = true;
      let params = {
        specialId: this.specialId,
        examId: this.data.examId,
        examTagId: this.data.list[this.data.listIndex]["id"]
      };
      assessApi.getExamSubject(params).then(res => {
        if (res.success) {
          this.test.list = [];
          res.data.forEach(item => {
            item.text = replaceinfo(item.text);
            item.options = item.options.map(rs => {
              rs.text = replaceinfo(rs.text);
              return rs;
            });
            this.test.list.push(item);
          });
          setTimeout(() => {
            window.MathJax.Hub.Queue([
              "Typeset",
              window.MathJax.Hub,
              document.getElementById("info")
            ]);
            this.butloading = false;
          }, 10);
        } else {
          if (res.code == 20006) {
            this.data.listIndex++;
            this.test.listIndex = 0;
            this.getExamSubject();
          } else if (res.code == 20009) {
            this.$router.push({
              name: "analyse",
              params: { sid: this.specialId, eid: this.data.examId }
            });
          } else {
            this.$toast.fail("获取题目数据失败");
          }
        }
      });
    },
    PostAnswer() {
      let answer =
        this.test.answer instanceof Array
          ? this.test.answer
          : this.test.answer.split(",");
      let params = {
        specialId: this.specialId,
        examId: this.data.examId,
        examTagId: this.data.list[this.data.listIndex]["id"],
        questionId: this.test.list[this.test.listIndex]["id"],
        answer: answer,
        startTime: this.test.startTime
      };
      assessApi.postAnswer(params).then(res => {
        if (res.success) {
          if (res.data.specialFinish != 0) {
            this.$router.push({
              name: "analyse",
              params: { sid: this.specialId, eid: this.data.examId }
            });
          } else {
            setTimeout(() => {
              window.MathJax.Hub.Queue([
                "Typeset",
                window.MathJax.Hub,
                document.getElementById("info")
              ]);
            }, 10);
            this.test.answer = [];
            this.timer = "0分0秒";
            this.minutes = 0;
            this.seconds = 0;
            this.test.startTime = new Date().getTime() / 1000;
            // 获取下一个知识点题目
            if (res.data.isNextTag != 0) {
              this.data.listIndex++;
              this.test.listIndex = 0;
              this.getExamSubject();
            } else {
              this.test.listIndex++;
            }
          }
        } else {
          if (res.code == 20003) {
            this.$dialog
              .alert({
                message:
                  "测评时间到，您未完成测评，本次测评无效，是否重新开始？",
                confirmButtonText: "重新测评",
                cancelButtonText: "退出"
              })
              .then(() => {
                this.isRestart = 1;
                this.show = true;
                this.data.listIndex = 0;
                this.test.listIndex = 0;
                this.test.answer = [];
                clearInterval(this.timeSender);
                this.timeSender = null;
                clearInterval(this.timeSender1);
                this.timeSender1 = null;
                this.timer = "0分0秒";
                this.minutes = 0;
                this.seconds = 0;
                this.allTimer = "0分0秒";
                this.allMinutes = 0;
                this.allSeconds = 0;
                this.startExam();
              })
              .catch(() => {
                this.$router.push({ name: "home" });
              });
          } else {
            this.$toast.fail(res.msg);
          }
        }
      });
    },
    startAnswer() {
      this.show = false;
      this.getExamSubject();
      this.created();
    },
    created() {
      this.timeSender = setInterval(this.startTimer, 1000);
      this.timeSender1 = setInterval(this.startAllTimer, 1000);
    },
    startTimer() {
      this.seconds++;
      if (this.seconds >= 60) {
        this.seconds = 0;
        this.minutes = this.minutes + 1;
      }
      this.timer = `${this.minutes}分${this.seconds}秒`;
    },
    startAllTimer() {
      this.allSeconds++;
      if (this.allSeconds >= 60) {
        this.allSeconds = 0;
        this.allMinutes = this.allMinutes + 1;
      }
      this.allTimer = `${this.allMinutes}分${this.allSeconds}秒`;
    },
    goUrl() {
      if (this.test.answer.length > 0) {
        this.PostAnswer();
      } else {
        this.$toast.fail("您忘了作答了，请先答题哦");
      }
      // this.$router.push({ name: "analyse" });
    },
    drawDelete() {
      this.$refs["in-draw-mask"].inDeleteCanvas();
    }
  },
  computed: {
    progress() {
      let count = this.data.list.length;
      let width = (this.data.listIndex / count) * 100;
      return width + "%";
    }
  },
  beforeDestroy() {
    clearInterval(this.timeSender);
    this.timeSender = null;
    clearInterval(this.timeSender1);
    this.timeSender1 = null;
  },
  filters: {
    format: function(value) {
      if (value > 60) {
        let i = parseInt(value / 60);
        let m = value - 60 * i;
        return i + "分" + m + "秒";
      } else {
        return value + "秒";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  $padding: 10px 16px;
  padding-bottom: 50px;
  // background-color: #fafafa;
  /deep/ img {
    max-width: 100%;
  }
  .dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background-color: #fff;
    color: #606266;
    img {
      width: 50%;
      margin: 20px auto;
      display: block;
    }
    img.mt {
      margin-top: 100px;
    }
    .title {
      padding: 30px 16px 10px;
      font-size: 20px;
      color: #333;
    }
    .desc {
      padding: 0 16px;
      font-size: 12px;
      color: #909399;
      line-height: 22px;
    }
    .tishi {
      text-indent: 30vw;
      font-size: 12px;
      line-height: 15px;
    }
  }
  .cell_title.van-cell {
    // background: rgb(236, 245, 255);
    border-bottom: 1px #eee solid;
  }
  .van-cell.noline::after {
    // background-color: #fafafa;
    border-bottom: none;
  }
  .time_desc {
    font-size: 12px;
    background-color: #fff;
    color: #606266;
    padding: 10px 16px;
    line-height: 24px;
    margin-bottom: 12px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .r {
      float: right;
    }
  }
  .title {
    /deep/ table {
      border-collapse: collapse;
      border: 1px #e4e7ed solid;
      td {
        border: 1px #e4e7ed solid;
      }
    }
    .type {
      color: #69b8fe;
      margin-right: 10px;
    }
  }
  .askLi {
    .van-checkbox,
    .van-radio {
      // height: 60px;
      font-size: 15px;
      // line-height: 60px;
      padding: 20px 0;
      border-bottom: 1px dashed #eee;
      /deep/ .van-checkbox__label {
        width: 100%;
      }
      /deep/ .van-radio__label {
        width: 100%;
      }
    }
  }
  .footer {
    width: 90%;
    position: fixed;
    left: 5%;
    bottom: 12px;
  }
  .progress {
    position: relative;
    margin-bottom: 12px;
    width: 100%;
    background-color: #ccc;
    height: 8px;
    border-radius: 8px;
    .strip {
      width: 100%;
      height: 8px;
      background-image: linear-gradient(to right, #8be7ff, #1cc5f0);
      border-radius: 8px;
    }
  }
  .draft {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 10px;
    bottom: 23px;
    background-color: #1cc5f0;
    border-radius: 50px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 1;
    border: 1px solid #fff;
    .van-icon {
      font-size: 25px;
      margin-top: 5px;
    }
  }
  .drawPage {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    .box {
      width: 100%;
      height: 100%;
      position: relative;
      .but {
        width: 100%;
        padding: 0 25px;
        position: absolute;
        bottom: 15px;
      }
    }
  }
}
</style>
